import { Controller } from "@hotwired/stimulus"

// Keep all six digits (including a leading zero). Never truncate a pasted
// value or extract digits from a message containing other text/numbers.
export default class extends Controller {
  connect() { this.normalize() }

  clean(value) {
    return value
      .replace(/[٠-٩۰-۹０-９]/g, character => {
        const point = character.codePointAt(0)
        return String(point - (point >= 0xff10 ? 0xff10 : point >= 0x06f0 ? 0x06f0 : 0x0660))
      })
      .replace(/[\p{White_Space}\p{Dash_Punctuation}\p{Format}\u2212]/gu, "")
  }

  normalize() {
    const input = this.element
    const position = input.selectionStart
    const before = input.value
    const value = this.clean(before)
    if (value !== before) {
      input.value = value
      if (position !== null) {
        const cursor = this.clean(before.slice(0, position)).length
        input.setSelectionRange(cursor, cursor)
      }
    }
    input.setCustomValidity(value && !/^[0-9]{6}$/.test(value)
      ? "Saisissez les 6 chiffres du code reçu par email." : "")
  }

  paste(event) {
    if (!event.clipboardData) return
    const code = this.clean(event.clipboardData.getData("text"))
    if (!/^[0-9]{6}$/.test(code)) return
    event.preventDefault()
    this.element.value = code
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
